document.addEventListener('DOMContentLoaded', () => {
    // Get all thumbnails and slides
    const thumbnailsStart = document.querySelector('.section-main-product').querySelectorAll('.product-thumbnail:not(.hidden)');
    const slidesStart = document.querySelector('.section-main-product').querySelectorAll('.product-gallery__slide:not(.hidden)');

    if(thumbnailsStart.length == 0 || slidesStart.length == 0){
      document.querySelector('.section-main-product').querySelectorAll('.product-thumbnail').forEach(thumbnail => {
        thumbnail.classList.toggle('hidden', false);
      });
  
      document.querySelector('.section-main-product').querySelectorAll('.product-gallery__slide').forEach(slide => {
          slide.classList.toggle('hidden', false);
      });
    }

    
  
    document.addEventListener('variant:change', (event) => {
        const variant = event.detail.variant;
        if (!variant) return;

        let section = document.querySelector('.section-main-product');
        if (!section) {
            section = event.target.closest('.product-grid');
        }
        if (!section) return;

        // Get all thumbnails and slides
        const thumbnails = section.querySelectorAll('.product-thumbnail');
        const slides = section.querySelectorAll('.product-gallery__slide');

        // Show/hide thumbnails and slides based on variant ID
        thumbnails.forEach(thumbnail => {
            const variantId = thumbnail.getAttribute('data-variant-id');
            thumbnail.classList.toggle('hidden', variantId !== String(variant.id));
        });

        slides.forEach(slide => {
            const variantId = slide.getAttribute('data-variant-id');
            slide.classList.toggle('hidden', variantId !== String(variant.id));
        });

      const thumbnailsNew = section.querySelectorAll('.product-thumbnail:not(.hidden)');
      const slidesNew = section.querySelectorAll('.product-gallery__slide:not(.hidden)');

      if(thumbnailsNew.length == 0 || slidesNew.length == 0){
        // Show/hide thumbnails and slides based on variant ID
        thumbnails.forEach(thumbnail => {
          thumbnail.classList.toggle('hidden', false);
        });
    
        slides.forEach(slide => {
            slide.classList.toggle('hidden', false);
        });
      }
    });
});